import { Button, Tooltip } from "@fluentui/react-components";
import {
  ArrowDownloadRegular,
  ArrowSyncCheckmarkRegular,
  DeleteDismissRegular,
} from "@fluentui/react-icons";
import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
} from "@silevis/reactgrid";
import * as React from "react";

export interface InsurerReportOptionsCell extends Cell {
  type: "insurerreportoptions";
  link?: string;
  deleteFn?: any;
  matchFn?: any;
  rowId?: any;
  selected?: boolean;
  highlighted?: boolean;
  t: any;
}

export class InsurerReportOptionsCellTemplate
  implements CellTemplate<InsurerReportOptionsCell>
{
  getCompatibleCell(
    uncertainCell: Uncertain<InsurerReportOptionsCell>
  ): Compatible<InsurerReportOptionsCell> {
    let t: any;
    t = getCellProperty(uncertainCell, "t", "function");

    let link: string | undefined;
    try {
      link = getCellProperty(uncertainCell, "link", "string");
    } catch {
      link = undefined;
    }

    let deleteFn: any;
    try {
      deleteFn = getCellProperty(uncertainCell, "deleteFn", "function");
    } catch {
      deleteFn = undefined;
    }

    let matchFn: any;
    try {
      matchFn = getCellProperty(uncertainCell, "matchFn", "function");
    } catch {
      matchFn = undefined;
    }

    let rowId: any;
    try {
      rowId = getCellProperty(uncertainCell, "rowId", "number");
    } catch {
      rowId = undefined;
    }

    let selected = false;
    try {
      selected = getCellProperty(uncertainCell, "selected", "boolean");
    } catch {
      selected = false;
    }
    let highlighted: boolean | undefined;
    try {
      highlighted = getCellProperty(uncertainCell, "highlighted", "boolean");
    } catch {
      highlighted = false;
    }

    const text = link;
    return {
      ...uncertainCell,
      link,
      text,
      rowId,
      deleteFn,
      matchFn,
      value: NaN,
      selected,
      highlighted,
      t,
    };
  }

  getClassName(
    cell: Compatible<InsurerReportOptionsCell>,
    isInEditMode: boolean
  ): string {
    return (
      (cell.className ? cell.className : "") +
      (cell.selected ? " rg-selected" : "") +
      (cell.highlighted ? " highlighted-selected-row" : "")
    );
  }

  render(
    cell: Compatible<InsurerReportOptionsCell>,
    isInEditMode: boolean,
    onCellChanged: (
      cell: Compatible<InsurerReportOptionsCell>,
      commit: boolean
    ) => void
  ): React.ReactNode {
    return <OptionsCell cell={cell} />;
  }
}

interface DIProps {
  cell: Record<string, any>;
}

const OptionsCell: React.FC<DIProps> = ({ cell }) => {
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      {cell.matchFn ? (
        <Tooltip
          content={cell.t("pct.rematchInsurerReport.label")}
          relationship="label"
        >
          <Button
            data-help="insurer-reports-row-rematch"
            appearance="subtle"
            size="small"
            icon={<ArrowSyncCheckmarkRegular />}
            onClick={() => {
              cell.matchFn(cell.rowId);
            }}
          ></Button>
        </Tooltip>
      ) : null}
      {cell.link ? (
        <Tooltip
          content={cell.t("pct.insurerReportDocumentPath.label")}
          relationship="label"
        >
          <Button
            data-help="insurer-reports-row-download"
            appearance="subtle"
            size="small"
            icon={<ArrowDownloadRegular />}
            onClick={() => {
              window.open(cell.link, "_blank");
            }}
          ></Button>
        </Tooltip>
      ) : null}
      {cell.deleteFn ? (
        <Tooltip
          content={cell.t("pct.deleteInsurerReport.label")}
          relationship="label"
        >
          <Button
            data-help="insurer-reports-row-delete"
            appearance="subtle"
            size="small"
            icon={<DeleteDismissRegular />}
            onClick={() => {
              cell.deleteFn(cell.rowId);
            }}
          ></Button>
        </Tooltip>
      ) : null}
    </div>
  );
};
